import { useDashboardFirstMetaSiteId } from './useDashboardFirstMetaSiteId';
import { useSiteCreationFolderId } from './useSiteCreationFolderId';
import { useInitialState } from '../contexts/InitialStateContext';

import { getViewUrl } from '../utils/getViewUrl';

export const useViewUrl = (data: { slug: string }) => {
  const { slug } = data;
  const dashboardFirstMetaSiteId = useDashboardFirstMetaSiteId();
  const siteCreationFolderId = useSiteCreationFolderId();
  const { locale } = useInitialState();

  const viewerUrl = new URL(getViewUrl({ language: locale, slug }));

  if (dashboardFirstMetaSiteId) {
    viewerUrl.searchParams.append(
      'dashboardFirstMetaSiteId',
      dashboardFirstMetaSiteId,
    );
  }
  if (siteCreationFolderId) {
    viewerUrl.searchParams.append('siteCreationFolderId', siteCreationFolderId);
  }

  return viewerUrl.href;
};
